import React, { useRef } from "react";
import { useTitleFontSize } from "../../hooks/use-title-font-size";
import nl2br from "react-nl2br";
import { motion } from "framer-motion";

export type TitleProps = {
  title?: string;
  subTitle?: string;
};

export const Title: React.FC<TitleProps> = ({ title, subTitle }) => {
  const ref = useRef<HTMLDivElement>(null);
  const fontSize = useTitleFontSize(ref, title);

  return (
    <motion.h1
      className="shindan-app__title"
      style={{
        visibility: title && subTitle ? "visible" : "hidden",
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ type: "spring", duration: 0.5 }}
    >
      <div className="shindan-app__title__safe">
        <div
          className="shindan-app__title__main"
          ref={ref}
          style={{ fontSize: fontSize }}
        >
          {nl2br(title)}診断
        </div>
        <div className="shindan-app__title__sub">{nl2br(subTitle)}</div>
      </div>
    </motion.h1>
  );
};
